import { useState } from 'react'
import { authAPI } from '../../../services/api'

export default function CustomerSecurityTab() {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setErrorMessage('')
    setSuccessMessage('')

    if (!currentPassword || !newPassword || !confirmPassword) {
      setErrorMessage('Bitte füllen Sie alle Felder aus')
      return
    }
    if (newPassword.length < 8) {
      setErrorMessage('Das neue Passwort muss mindestens 8 Zeichen lang sein')
      return
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage('Die neuen Passwörter stimmen nicht überein')
      return
    }
    if (currentPassword === newPassword) {
      setErrorMessage('Das neue Passwort muss sich vom aktuellen Passwort unterscheiden')
      return
    }

    setLoading(true)
    try {
      await authAPI.changePasswordCustomer(currentPassword, newPassword)
      setSuccessMessage('Passwort erfolgreich geändert')
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
      setTimeout(() => setSuccessMessage(''), 3000)
    } catch (error: any) {
      if (error.response?.status === 400) {
        setErrorMessage('Falsches aktuelles Passwort')
      } else {
        setErrorMessage(error.response?.data?.detail || 'Fehler beim Ändern des Passworts')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="wc-card wc-elev-sm" style={{ gap: 18 }}>
      <div>
        <h3 className="wc-card-title" style={{ margin: 0 }}>Passwort ändern</h3>
        <p className="wc-muted" style={{ fontSize: 13, margin: '4px 0 0' }}>Aktualisieren Sie Ihr Passwort, um Ihr Konto zu sichern</p>
      </div>

      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 16 }}>
        <div className="wc-field">
          <label htmlFor="currentPassword">Aktuelles Passwort</label>
          <input
            id="currentPassword"
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Geben Sie Ihr aktuelles Passwort ein"
            autoComplete="current-password"
            className="wc-input"
          />
        </div>

        <div className="wc-field">
          <label htmlFor="newPassword">Neues Passwort</label>
          <input
            id="newPassword"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Mindestens 8 Zeichen"
            autoComplete="new-password"
            className="wc-input"
          />
          <p className="wc-muted" style={{ fontSize: 12, margin: '6px 0 0' }}>Mindestens 8 Zeichen lang</p>
        </div>

        <div className="wc-field">
          <label htmlFor="confirmPassword">Neues Passwort bestätigen</label>
          <input
            id="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Wiederholen Sie Ihr neues Passwort"
            autoComplete="new-password"
            className="wc-input"
          />
        </div>

        {successMessage && <div className="wc-alert wc-alert-success">{successMessage}</div>}
        {errorMessage && <div className="wc-alert wc-alert-error">{errorMessage}</div>}

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button type="submit" disabled={loading} className="wc-btn wc-btn-primary">
            {loading ? 'Wird geändert…' : 'Passwort ändern'}
          </button>
        </div>
      </form>
    </div>
  )
}
